import React from 'react';
import ContactSection from '../components/home/ContactSection';
import SEOHead from '@/components/SEOHead';

export default function Contact() {
  return (
    <div className="pt-20">
      <SEOHead
        title="Contact Us"
        description="Get in touch with the BuildersLab team. We're here to help with questions about our AI website builder, custom development, or partnerships."
        ogUrl="https://builderslab.net/Contact"
      />
      <ContactSection />
    </div>
  );
}